import { render, staticRenderFns } from "./mdProductInfo.vue?vue&type=template&id=d806cb2a&scoped=true&"
import script from "./mdProductInfo.vue?vue&type=script&lang=js&"
export * from "./mdProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./mdProductInfo.vue?vue&type=style&index=0&id=d806cb2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d806cb2a",
  null
  
)

export default component.exports